export const CUSTOMER_DISPLAY_ROUTES = {
  idle: '/customer_display',
  cart: '/customer_display/cart',
  quote: '/customer_display/quote',
  search: '/customer_display/search',
}

const CUSTOMER_DISPLAY_NAVIGATION_ROUTES = [
  CUSTOMER_DISPLAY_ROUTES.search,
  CUSTOMER_DISPLAY_ROUTES.cart,
]

export const isCustomerDisplayNavigationRoute = pathname =>
  CUSTOMER_DISPLAY_NAVIGATION_ROUTES.includes(pathname)
